<template>
    <router-view></router-view>
</template>

<script>

import * as spinners from 'epic-spinners'
import FaturasBoletos from './components/FaturasBoletos.vue'
import FaturasCadastradas from './components/FaturasCadastradas.vue'
import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
import FaturamentoCard from './components/FaturamentoCard.vue'
import VuesticAccordion from '../../vuestic-theme/vuestic-components/vuestic-collapse/VuesticAccordion.vue'
import urlApiV2 from '@/router/urlApiV2.js'
//import Alunos from '../monitoria/alunos/Alunos.vue'


export default {

    components: {
        VuesticAccordion,
        ...spinners,
        FaturasBoletos,
        FaturasCadastradas,
        DateIconGroup,
        FaturamentoCard
        //Alunos
    },

    data () {
        return {
            
            
        }
    },

    methods: {
        
    },    
}
</script>

<style lang="scss" scoped>

#conteudo_tabs {
    margin-top: 20px;
}

// PREDEFINIÇÕES DAS TABS

.nav {
    display: flex;
}

.nav-tabs {
    border: 0px;
}

.nav-tabs .nav-link {
    border: 0px;
}

.nav-link {
    color: #1c2d5a !important;
    font-weight: 700;
    border-bottom: #1c2d5a;
    border-radius: 5px;
}

.nav-link.active {
    color: white !important;
    background-color: #1c2d5a;
    font-weight: 700;
    border-color: #1c2d5a;
    border-radius: 5px;
}

@media(max-width: 768px) {

    .nav {
        display: block;
    }

    .nav-item {
        margin-bottom: 5px;
        border-bottom: 4px solid rgb(211, 210, 210);
        border-radius: 5px;
    }
}
</style>